import React, { useEffect, useState } from "react";
import style from "./EducationResourceDirectory.module.css";
import educationDirectory from "../../assets/images/educationDirectory.png";
import Input from "../input/Input";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../menu/Loader";
import { decodeHtmlEntities } from "../../utilities/DecodeEntity";
import { fetchEducationResource } from "../../stores/slices/educationResourceDirectorySlice";
import validateInput from "../../utilities/validations/validateInput";
import { Search } from "react-feather";

function ResourceDirectory() {
  const data = useSelector(
    (state) => state.educationResourceDirectorySlice.educationResource
  );
  const dispatch = useDispatch();
  const [visibleItems, setVisibleItems] = useState(10);
  const [multiSelect, setMultiSelect] = useState({});
  const [filterResource, setFilterResource] = useState(undefined);
  const [featuredPost, setFeaturedPost] = useState(undefined);
  const [checkBoxArray, setCheckBoxArray] = useState([]);
  const [useEffectCallFlag, setUseEffectCallFlag] = useState(false);
  const [paramData, setParamData] = useState([]);
  const [post, setPost] = useState(undefined);
  const [inputSearch, setInputSearch] = useState({
    value: "",
    isValid: true,
  });
  const [sortBy, setSortBy] = useState({
    value: "",
    isValid: true,
  });
  const loadMoreItems = () => {
    setVisibleItems((prevVisibleItems) => prevVisibleItems + 10);
  };
  const inputOnChange = (e, fieldvalidation) => {
    let inputValue = e.target.value;
    let name = e.target.name;
    let inputValidate = validateInput(inputValue, fieldvalidation);

    setInputSearch((prevState) => ({
      value: inputValidate.value,
      isValid: inputValidate.isValid,
    }));
  };
  // filter check box functions
  const handleResourceFilterCheckbox = (e, index, ID, name1, key) => {
    setUseEffectCallFlag(true);
    let inputValue = e.target.value;
    let name = e.target.name;

    setMultiSelect((prevState) => {
      // If the category does not exist, initialize it
      const category = prevState[name] || [];
      const updatedCategory = category.map((data, i) =>{
      return  index === i+1 ? { ...data, isChecked: !data.isChecked } : data
      }
      );

      // If the index does not exist in the category, add the new filter
      if (!category.some((data, i) => i === index)) {
        updatedCategory.push({
          id: ID,
          name: name1,
          isChecked: e.target.checked,
        });
      }
      return {
        ...prevState,
        [name]: updatedCategory,
      };
    });
    setFilterResource((prevState) => ({
      ...prevState,
      [name]: prevState[name].map((data, i) =>
        index == i ? { ...data, isChecked: !data.isChecked } : data
      ),
    }));

    if (e.target.checked) {
      setCheckBoxArray([...checkBoxArray, name1 + ID]);
    } else {
      setCheckBoxArray((prevArr) =>
        prevArr.filter((item) => item !== name1 + ID)
      );
      setMultiSelect((prevState) => ({
        ...prevState,
        [name]: prevState[name].filter((item) => item.id !== ID),
      }));
    }
    //     setMultiSelect((prevArr) =>
    //     prevArr.filter((item) => item.id !== ID)
    //   );

    // update api param
    let dataKey = "";
    if (key == "CATEGORY") {
      dataKey = "category";
    } else if (key == "EDUCATIONAL TOPICS") {
      dataKey = "topic";
    } else if (key == "CONTENT TYPE") {
      dataKey = "contenttype";
    } else if (key == "LANGUAGE") {
      dataKey = "language";
    } else {
      dataKey = key;
    }
    addKeyValueParam(dataKey, ID, e.target.checked);
  };
  const addKeyValueParam = (key, value, checked) => {
    setParamData((prevData) => {
      if (checked) {
        // If key is 'sortby', replace the existing 'sortby' parameter
        if (key === "sortby") {
          const filteredData = prevData.filter(
            (obj) => Object.keys(obj)[0] !== "sortby"
          );
          return [...filteredData, { [key]: value }];
        }
        return [...prevData, { [key]: value }];
      } else {
        return prevData.filter((obj) => obj[key] !== value);
      }
    });
  };

  const sortByonChange = (e) => {
    let inputValue = e.target.value;
    let name = e.target.name;
    setUseEffectCallFlag(true);
    setSortBy((prevState) => ({
      value: inputValue,
      isValid: true,
    }));
    let dataKey = `sortby`;
    addKeyValueParam(dataKey, inputValue, true);
  };
  // searc button functions
  const searchBtn = () => {
    setUseEffectCallFlag(true);
    let dataKey = "search";
    let value = inputSearch.value;
    setMultiSelect((prevState) => ({
      ...prevState,
      [dataKey]: [
        {
          id: value,
          name: value,
          isChecked: true,
        },
      ],
    }));
    addKeyValueParam(dataKey, value, true);
  };

  // remove filter function
  const removeFilter = (key, filterToRemove) => {
    setUseEffectCallFlag(true);
    // update api param
    let dataKey = "";
    if (key == "CATEGORY") {
      dataKey = "category";
    } else if (key == "EDUCATIONAL TOPICS") {
      dataKey = "topic";
    } else if (key == "CONTENT TYPE") {
      dataKey = "contenttype";
    } else if (key == "LANGUAGE") {
      dataKey = "language";
    } else {
      dataKey = key;
    }
    addKeyValueParam(dataKey, filterToRemove.id, false);
    setMultiSelect((prevState) => ({
      ...prevState,
      [key]: prevState[key].filter((item) => item.id !== filterToRemove.id),
    }));
    setCheckBoxArray((prevArr) =>
      prevArr.filter((item) => item !== filterToRemove.name + filterToRemove.id)
    );
  };

  //clear function
  const clearFilter = () => {
    setFilterResource((prevState) => {
      const updatedState = {};
      setCheckBoxArray([]);
      // Iterate over each key in prevState and update the array using map
      Object.keys(prevState).map((key) => {
        updatedState[key] = prevState[key].map((item) => ({
          ...item,
          isChecked: item.isChecked && false, // Toggle isChecked
        }));
      });

      return updatedState;
    });
    setMultiSelect([]);
    setInputSearch((prevState) => ({
      value: "",
      isValid: true,
    }));
    setSortBy((prevState) => ({
      value: "",
      isValid: true,
    }));
    setParamData([]);
    let params = null;
    dispatch(fetchEducationResource(params));
  };

  // update store data
  useEffect(() => {
    setVisibleItems(10);
    setFilterResource(data.allCategoryObj);
    setPost(data.post);
    setFeaturedPost(data.featuredPost);
  }, [data.allCategoryObj]);

  //API call useEffect
  useEffect(() => {
    if (useEffectCallFlag) {
      setUseEffectCallFlag(false);
      const paramsD = paramData.reduce((acc, obj) => {
        for (const [key, value] of Object.entries(obj)) {
          if (acc.hasOwnProperty(key)) {
            acc[key] += `,${value}`;
          } else {
            acc[key] = value;
          }
        }
        return acc;
      }, {});

      const params = Object.entries(paramsD)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
      dispatch(fetchEducationResource(params));
    }
  }, [useEffectCallFlag]);

  let checkBox = JSON.stringify(checkBoxArray);
  let sortDropDwon = [
    { key: "asc", value: "Title (A-Z)" },
    { key: "desc", value: "Title (Z-A)" },
    { key: "latest", value: "Date (Newest)" },
    { key: "old", value: "Date (Oldest)" },
  ];
  return (
    <div className={`${style.search_details}`}>
      <div className={`p-2 ${style.search_header}`}>
      Education Resource Library
      </div>
      <div
        style={{ color: "black" }}
        className="grid columns-12 gap-6 mt-5 mb-5"
      >
        <div className="g-col-12 g-col-sm-4 g-col-xl-4 mt-2 intro-y">
          <div>
            <div className="grid columns-12 gap-4 gap-y-5 mt-5 mb-4">
              <div
                className="intro-y g-col-12 g-col-md-12 g-col-xl-12 mb-5 pt-6"
                style={{ position: "relative" }}
              >
                <Input
                  width="100%"
                  type="text"
                  id="SearchResources"
                  label="Search Resources"
                  name="addressType"
                  value={inputSearch.value}
                  isValid={true}
                  onChange={(e) => inputOnChange(e, "name")}
                  // errorMsg={errorMessage?.inputErrorMessage}
                  maxLength="100"
                />
                <span className="search_button" onClick={() => searchBtn()}>
                  <Search />
                </span>
              </div>
            </div>
            <div>
              <div>
                <a
                  href="https://education.patientadvocate.org"
                  class="filters2-overlay -as:1"
                  clickable=""
                ></a>
                <div className="px-8">
                  <p
                    className="fw-semibold fs-xl"
                    style={{ borderBottom: "3px solid black" }}
                  >
                    FILTER BY:
                  </p>
                  <div>
                    {filterResource &&
                      Object.keys(filterResource).map((keys, index) => {
                        return (
                          <>
                            <div
                              style={{ borderBottom: "1px solid grey" }}
                              className="mt-3 mb-3"
                              key={index}
                            >
                              <p className={"fw-semibold fs-lg mt-2"}>
                                <b>{keys && keys}</b>
                              </p>
                              {filterResource[keys].map((x, index) => {
                                return (
                                  <>
                                    <div className="">
                                      <span key={index}>
                                        <Input
                                          decodFlag={true}
                                          type="checkboxFS"
                                          id={`check${x.ID}`}
                                          labelPosition="left"
                                          name={keys}
                                          label={x.name}
                                          value={x.ID}
                                          onClick={(e) =>
                                            handleResourceFilterCheckbox(
                                              e,
                                              index+1,
                                              x.ID,
                                              x.name,
                                              keys
                                            )
                                          }
                                          checked={
                                            checkBox.includes(x.name + x.ID)
                                              ? true
                                              : false
                                          }
                                        />
                                        <br />
                                      </span>
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          </>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="g-col-12 g-col-sm-8 g-col-xl-8 mt-2 intro-y">
          <div style={{ borderLeft: "1px solid grey" }}>
            <div className="pt-3 mt-5 px-8">
              <div
                className="d-flex justify-content-between"
                style={{ borderBottom: "1px solid grey" }}
              >
                <p style={{ padding: "37px 0px 0px 0px" }}>
                  {data?.postCount} resources
                </p>
                <p className="pb-2">
                  {" "}
                  <Input
                    type="select_NFRD"
                    id="sort_By"
                    label={"Sort By"}
                    name="sortBy"
                    value={sortBy.value}
                    isValid={true}
                    onChange={(e) => sortByonChange(e, "state")}
                    // errorMsg={selectedLanguage?.inputErrorMessage}
                    elmentconfig={sortDropDwon}
                  />
                </p>
              </div>
            </div>
            <div className="mt-5 mb-5 pt-5 px-8">
              <div className="row">
                <div className="col-md-9 row">
                  {Object.keys(multiSelect).map((keys, index) => {
                    return multiSelect[keys].map((x, index) => {
                      return (
                        <span
                          key={index}
                          style={{ width: "auto", padding: "5px" }}
                        >
                          <div className="filter-tag">
                            {decodeHtmlEntities(x.name)}{" "}
                            <span
                              className="filter-close"
                              onClick={(e) => removeFilter(keys, x)}
                            >
                              &times;
                            </span>
                          </div>
                        </span>
                      );
                    });
                  })}
                </div>
                <div className="col-md-3 text-end">
                  {" "}
                  <button
                    className={`btn btn-yellow fs-base`}
                    onClick={() => clearFilter()}
                  >
                    Clear filters
                  </button>
                </div>
              </div>
            </div>
            <a href={featuredPost?.url} target="_blank">
              <div className="d-flex justify-content-between px-8 mb-5 mt-5 pb-5">
                <img src={featuredPost?.image} alt="" style={{ width: "46%" }} />
                <div className="ms-5">
                  <p className="fw-bold fs-3xl">{featuredPost?.title}</p>
                  {/* <p className='mt-1'>{featuredPost?.name}</p> */}
                </div>
              </div>
            </a>
            {post == undefined || post.length == 0 ? (
              <div className="text-center">
                <p className="fw-bold mt-1" style={{fontSize:"30px"}}>Resources not found!</p>
              </div>
            ) : (
              <div className="grid columns-12 gap-6">
                {post?.slice(0, visibleItems).map((val) => {
                  return (
                    <a
                      href={val?.url}
                      target="_blank"
                      className="g-col-12 g-col-sm-6 g-col-xl-6 "
                    >
                      <div className="mt-5 pt-5 px-8 g-col-12 g-col-sm-6 g-col-xl-6 intro-y">
                        <img src={val.image} alt="" style={{ width: "100%" }} />
                        <p className="fw-bold fs-xl mt-1">{val?.title}</p>
                      </div>
                    </a>
                  );
                })}
              </div>
            )}

            {post?.length >= 10 ? (
              <>
                {post?.length < visibleItems ? null : (
                  <div className="mt-5 text-center">
                    <button
                      className="btn verifyAddres"
                      onClick={loadMoreItems}
                    >
                      LOAD MORE
                    </button>
                  </div>
                )}
              </>
            ) : null}
          </div>
        </div>
      </div>
      <div
        aria-labelledby="widget-title-contact_us-19332"
        className={`${style.section} mt-8`}
      >
        <div data-v-eb0e1678="" className={style.info}>
          <h4 className="fw-bold fs-lg">We Want to Hear from You!</h4>
          <p></p>
          <p className="fs-sm mt-2">
            Click the{" "}
            <a href="mailto:education@patientadvocate.org">
              <strong>Contact Us</strong>
            </a>{" "}
            button for questions, feedback, or suggestions on resources and new
            features.
            <br />
          </p>
          <p className="mt-2 fs-sm">
            <a href="https://www.patientadvocate.org/contact/reach-out/">
              <strong>Complete this form</strong>
            </a>{" "}
            if you are interested in volunteering your time. We appreciate when
            English and Spanish speakers can help review new education
            materials we create.
          </p>
          <p></p>
          <a
            href="https://www.patientadvocate.org/contact/"
            target="_blank"
            className="verifyAddres btn mt-2"
          >
            Contact Us
          </a>
        </div>
        <div data-v-eb0e1678="">
          <div data-v-eb0e1678="">
            <img
              data-v-eb0e1678=""
              src={educationDirectory}
              role="presentation"
              alt="Contact Us"
            />
          </div>
        </div>
      </div>
      {data.loader && <Loader />}
    </div>
  );
}

export default ResourceDirectory;
